// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.gray {
  color: #292727;
}

.alarm-modal-wrapper {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 6000;
  display: flex;
  align-items: center;
  justify-content: center;
}
.alarm-modal-wrapper .alarm-modal {
  background: #ffffff;
  width: 280px;
  border: 1px solid #515554;
  display: flex;
  flex-direction: column;
  align-items: unset;
  box-shadow: 1px 3px 8px -1px #9c9c9c;
}
.alarm-modal-wrapper .alarm-modal__header {
  display: flex;
  align-items: center;
  padding: 1.8rem 0.4rem;
}
.alarm-modal-wrapper .alarm-modal__header .back-button {
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
  margin-right: 0.8rem;
  display: flex;
  align-items: center;
}
.alarm-modal-wrapper .alarm-modal__header .back-button .back-button-icon {
  color: #9c9c9c;
  font-size: 2.4rem;
  font-weight: 500;
}
.alarm-modal-wrapper .alarm-modal__header span {
  font-size: 1.7rem;
  font-weight: 600;
  color: #696969;
}
.alarm-modal-wrapper .alarm-modal__body {
  padding: 0px 1.5rem;
  flex-grow: 1;
}
.alarm-modal-wrapper .alarm-modal__body .alarm-modal__date-section {
  display: flex;
  align-items: center;
  margin-bottom: 2.4rem;
}
.alarm-modal-wrapper .alarm-modal__body .alarm-modal__date-section .inline-label {
  font-weight: 500;
  color: #696969;
  margin-right: 2.5rem;
}
.alarm-modal-wrapper .alarm-modal__body .alarm-modal__date-section .date-picker-wrapper {
  width: 100%;
}
.alarm-modal-wrapper .alarm-modal__body .alarm-modal__date-section .date-picker-wrapper .react-datepicker-wrapper {
  margin-top: 0.5rem;
}
.alarm-modal-wrapper .alarm-modal__body .alarm-modal__date-section .date-picker-wrapper .react-datepicker-wrapper .minimal-input {
  border-bottom: 1px solid #efefef !important;
  color: #696969;
  margin-left: 1.5rem;
  width: 95%;
  padding-bottom: 0.4rem;
  caret-color: transparent;
}
.alarm-modal-wrapper .alarm-modal__body .alarm-modal__date-section .Select-value {
  padding-left: 0;
}
.alarm-modal-wrapper .alarm-modal__body .alarm-modal__date-section .Select-value-label {
  color: #696969;
  font-size: 1.4rem;
  font-weight: 500;
}
.alarm-modal-wrapper .alarm-modal__body .alarm-modal__date-section .Select.is-open .Select-menu-outer .Select-option {
  font-size: 1.4rem;
  font-weight: 500;
  color: #696969;
}
.alarm-modal-wrapper .alarm-modal__body .alarm-modal__date-section .react-datepicker-popper {
  z-index: 3;
}
.alarm-modal-wrapper .alarm-modal__body .alarm-modal__time-options .time-option {
  display: flex;
  align-items: center;
  margin-bottom: 1.2rem;
}
.alarm-modal-wrapper .alarm-modal__body .alarm-modal__time-options .time-option input[type=checkbox].alarm-checkbox {
  display: none;
}
.alarm-modal-wrapper .alarm-modal__body .alarm-modal__time-options .time-option input[type=checkbox].alarm-checkbox + label {
  position: relative;
  padding-left: 2.2rem;
  cursor: pointer;
  display: flex;
  align-items: center;
  flex: 1;
}
.alarm-modal-wrapper .alarm-modal__body .alarm-modal__time-options .time-option input[type=checkbox].alarm-checkbox + label:before {
  content: "";
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  width: 1.2rem;
  height: 1.2rem;
  border: 1px solid #515554;
  border-radius: 50%;
  background: #ffffff;
}
.alarm-modal-wrapper .alarm-modal__body .alarm-modal__time-options .time-option input[type=checkbox].alarm-checkbox + label:after {
  content: "";
  width: 1.2rem;
  height: 1.2rem;
  background: #696969;
  position: absolute;
  top: 50%;
  left: 0px;
  border-radius: 50%;
  opacity: 0;
  transform: translateY(-50%);
}
.alarm-modal-wrapper .alarm-modal__body .alarm-modal__time-options .time-option input[type=checkbox].alarm-checkbox:checked + label:after {
  opacity: 1;
}
.alarm-modal-wrapper .alarm-modal__body .alarm-modal__time-options .time-option .normal {
  font-weight: 500;
  color: #696969;
}
.alarm-modal-wrapper .alarm-modal__body .alarm-modal__time-options .time-option .time-value {
  margin-left: auto;
  color: #696969;
}
.alarm-modal-wrapper .alarm-modal__body .alarm-modal__time-options .time-option.custom-option {
  cursor: pointer;
}
.alarm-modal-wrapper .alarm-modal__body .alarm-modal__time-options .time-option.custom-option .custom-chevron {
  margin-left: auto;
  color: #9c9c9c;
  font-size: 2.4rem;
  margin-bottom: 0.5rem;
}
.alarm-modal-wrapper .alarm-modal__body .alarm-modal__recurring-section h3 {
  color: #696969;
  font-size: 1.6rem;
  margin-bottom: 1.6rem;
  font-weight: 600;
}
.alarm-modal-wrapper .alarm-modal__body .alarm-modal__recurring-section .recurring-option input[type=checkbox].alarm-checkbox {
  display: none;
}
.alarm-modal-wrapper .alarm-modal__body .alarm-modal__recurring-section .recurring-option input[type=checkbox].alarm-checkbox + label {
  position: relative;
  padding-left: 2.2rem;
  cursor: pointer;
  display: flex;
  align-items: center;
  margin-bottom: 1.5rem;
  flex: 1;
}
.alarm-modal-wrapper .alarm-modal__body .alarm-modal__recurring-section .recurring-option input[type=checkbox].alarm-checkbox + label:before {
  content: "";
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  width: 1.2rem;
  height: 1.2rem;
  border: 1px solid #515554;
  border-radius: 50%;
  background: #ffffff;
}
.alarm-modal-wrapper .alarm-modal__body .alarm-modal__recurring-section .recurring-option input[type=checkbox].alarm-checkbox + label:after {
  content: "";
  width: 1.2rem;
  height: 1.2rem;
  background: #696969;
  position: absolute;
  top: 50%;
  left: 0px;
  border-radius: 50%;
  opacity: 0;
  transform: translateY(-50%);
}
.alarm-modal-wrapper .alarm-modal__body .alarm-modal__recurring-section .recurring-option input[type=checkbox].alarm-checkbox:checked + label:after {
  opacity: 1;
}
.alarm-modal-wrapper .alarm-modal__body .alarm-modal__recurring-section .recurring-option .normal {
  font-weight: 500;
  color: #696969;
}
.alarm-modal-wrapper .alarm-modal__footer {
  padding: 0px 0px 2rem;
  display: flex;
  justify-content: center;
}
.alarm-modal-wrapper .alarm-modal__footer .update-alarm-button {
  color: #696969;
  min-width: 120px;
  font-size: 1.3rem;
  border: none;
}`, "",{"version":3,"sources":["webpack://./src/Styles/Colors.scss","webpack://./src/Components/Global/ChecklistsDisplay/AddAlarmModal.scss","webpack://./src/Styles/Variables.scss"],"names":[],"mappings":"AAsCA;EACE,cArCU;ACAZ;;AACA;EACE,eAAA;EACA,MAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EACA,aC0Be;EDzBf,aAAA;EACA,mBAAA;EACA,uBAAA;AAEF;AAAE;EACE,mBDHc;ECId,YAAA;EACA,yBAAA;EACA,aAAA;EACA,sBAAA;EACA,kBAAA;EACA,oCAAA;AAEJ;AAAI;EACE,aAAA;EACA,mBAAA;EACA,sBAAA;AAEN;AAAM;EACE,gBAAA;EACA,YAAA;EACA,eAAA;EACA,UAAA;EACA,oBAAA;EACA,aAAA;EACA,mBAAA;AAER;AAAQ;EACE,cDnBE;ECoBF,iBAAA;EACA,gBAAA;AAEV;AAEM;EACE,iBAAA;EACA,gBAAA;EACA,cD5CQ;AC4ChB;AAII;EACE,mBAAA;EACA,YAAA;AAFN;AAIM;EACE,aAAA;EACA,mBAAA;EACA,qBAAA;AAFR;AAIQ;EACE,gBAAA;EACA,cD3DM;EC4DN,oBAAA;AAFV;AAKQ;EACE,WAAA;AAHV;AAKU;EACE,kBAAA;AAHZ;AAKY;EACE,2CAAA;EACA,cDvEE;ECwEF,mBAAA;EACA,UAAA;EACA,sBAAA;EACA,wBAAA;AAHd;AAQQ;EACE,eAAA;AANV;AASQ;EACE,cDrFM;ECsFN,iBAAA;EACA,gBAAA;AAPV;AAYY;EACE,iBAAA;EACA,gBAAA;EACA,cD/FE;ACqFhB;AAeQ;EACE,UAAA;AAbV;AAkBQ;EACE,aAAA;EACA,mBAAA;EACA,qBAAA;AAhBV;AAkBU;EACE,aAAA;AAhBZ;AAkBY;EACE,kBAAA;EACA,oBAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,OAAA;AAhBd;AAkBc;EACE,WAAA;EACA,kBAAA;EACA,OAAA;EACA,QAAA;EACA,2BAAA;EACA,aAAA;EACA,cAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBD3HE;AC2GlB;AAmBc;EACE,WAAA;EACA,aAAA;EACA,cAAA;EACA,mBD3IA;EC4IA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,kBAAA;EACA,UAAA;EACA,2BAAA;AAjBhB;AAqBY;EACE,UAAA;AAnBd;AAuBU;EACE,gBAAA;EACA,cD5JI;ACuIhB;AAwBU;EACE,iBAAA;EACA,cDjKI;AC2IhB;AAyBU;EACE,eAAA;AAvBZ;AAyBY;EACE,iBAAA;EACA,cDzJF;EC0JE,iBAAA;EACA,qBAAA;AAvBd;AA8BQ;EACE,cDnLM;ECoLN,iBAAA;EACA,qBAAA;EACA,gBAAA;AA5BV;AAgCU;EACE,aAAA;AA9BZ;AAgCY;EACE,kBAAA;EACA,oBAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,qBAAA;EACA,OAAA;AA9Bd;AAgCc;EACE,WAAA;EACA,kBAAA;EACA,OAAA;EACA,QAAA;EACA,2BAAA;EACA,aAAA;EACA,cAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBDvME;ACyKlB;AAiCc;EACE,WAAA;EACA,aAAA;EACA,cAAA;EACA,mBDvNA;ECwNA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,kBAAA;EACA,UAAA;EACA,2BAAA;AA/BhB;AAmCY;EACE,UAAA;AAjCd;AAqCU;EACE,gBAAA;EACA,cDxOI;ACqMhB;AAyCI;EACE,qBAAA;EACA,aAAA;EACA,uBAAA;AAvCN;AAyCM;EACE,cDpPQ;ECqPR,gBAAA;EACA,iBAAA;EACA,YAAA;AAvCR","sourcesContent":["// Define colors here to use across the site\n\n$textColor: #292727;\n$darkTextColor: #696969;\n$lightTextColor: #cacacb;\n$black: black;\n$borderColor: #c0c0c0;\n$gridBorderColor: #ddd;\n$hoverColor: #b8b8b8;\n$shadow: #9c9c9c;\n$gray: #efefef;\n$darkGray: #515554;\n$backgroundColor: #ffffff;\n$backgroundRight: #ffffff;\n$backgroundLeft: #e9e9e9;\n$success: #18b100;\n$headingsGray: #333333;\n$camelGold: #d0ad4d;\n$gold: #dabc64;\n$iconColor: #9c9c9c;\n$navIcon: #4d4d4d;\n$navIconActive: #dabc64;\n$iconColorActive: #dabc64;\n$magenta: #ab3a72;\n$habitPrimary: rgb(51, 51, 51);\n$habitBorder: rgb(208, 213, 221);\n$habitActionText: rgb(86, 86, 86);\n$habitActionIcon: #565656;\n\n// Brands\n$brand-primary: #3097d1;\n$brand-info: #8eb4cb;\n$brand-success: #2ab27b;\n$brand-warning: #cbb956;\n$brand-danger: red;\n\n$orange: #f5a000;\n\n.gray {\n  color: $textColor;\n}\n\n$input-color: #555;\n\n$headingColor: #999;\n$dayHeadingColor: #555;\n$undoBackground: #bdbdbd;\n","@import '~/Styles/Colors';\n@import '~/Styles/Variables';\n\n.alarm-modal-wrapper {\n  position: fixed;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  z-index: $modalBaseLayer;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  .alarm-modal {\n    background: $backgroundColor;\n    width: 280px;\n    border: 1px solid $darkGray;\n    display: flex;\n    flex-direction: column;\n    align-items: unset;\n    box-shadow: 1px 3px 8px -1px $shadow;\n\n    &__header {\n      display: flex;\n      align-items: center;\n      padding: 1.8rem 0.4rem;\n\n      .back-button {\n        background: none;\n        border: none;\n        cursor: pointer;\n        padding: 0;\n        margin-right: 0.8rem;\n        display: flex;\n        align-items: center;\n\n        .back-button-icon {\n          color: $iconColor;\n          font-size: 2.4rem;\n          font-weight: 500;\n        }\n      }\n\n      span {\n        font-size: 1.7rem;\n        font-weight: 600;\n        color: $darkTextColor;\n      }\n    }\n\n    &__body {\n      padding: 0px 1.5rem;\n      flex-grow: 1;\n\n      .alarm-modal__date-section {\n        display: flex;\n        align-items: center;\n        margin-bottom: 2.4rem;\n\n        .inline-label {\n          font-weight: 500;\n          color: $darkTextColor;\n          margin-right: 2.5rem;\n        }\n\n        .date-picker-wrapper {\n          width: 100%;\n\n          .react-datepicker-wrapper {\n            margin-top: 0.5rem;\n\n            .minimal-input {\n              border-bottom: 1px solid $gray !important;\n              color: $darkTextColor;\n              margin-left: 1.5rem;\n              width: 95%;\n              padding-bottom: 0.4rem;\n              caret-color: transparent;\n            }\n          }\n        }\n\n        .Select-value {\n          padding-left: 0;\n        }\n\n        .Select-value-label {\n          color: $darkTextColor;\n          font-size: 1.4rem;\n          font-weight: 500;\n        }\n\n        .Select.is-open {\n          .Select-menu-outer {\n            .Select-option {\n              font-size: 1.4rem;\n              font-weight: 500;\n              color: $darkTextColor;\n            }\n          }\n        }\n\n        .react-datepicker-popper {\n          z-index: 3;\n        }\n      }\n\n      .alarm-modal__time-options {\n        .time-option {\n          display: flex;\n          align-items: center;\n          margin-bottom: 1.2rem;\n\n          input[type='checkbox'].alarm-checkbox {\n            display: none;\n\n            & + label {\n              position: relative;\n              padding-left: 2.2rem;\n              cursor: pointer;\n              display: flex;\n              align-items: center;\n              flex: 1;\n\n              &:before {\n                content: '';\n                position: absolute;\n                left: 0;\n                top: 50%;\n                transform: translateY(-50%);\n                width: 1.2rem;\n                height: 1.2rem;\n                border: 1px solid $darkGray;\n                border-radius: 50%;\n                background: $backgroundColor;\n              }\n\n              &:after {\n                content: '';\n                width: 1.2rem;\n                height: 1.2rem;\n                background: $darkTextColor;\n                position: absolute;\n                top: 50%;\n                left: 0px;\n                border-radius: 50%;\n                opacity: 0;\n                transform: translateY(-50%);\n              }\n            }\n\n            &:checked + label:after {\n              opacity: 1;\n            }\n          }\n\n          .normal {\n            font-weight: 500;\n            color: $darkTextColor;\n          }\n\n          .time-value {\n            margin-left: auto;\n            color: $darkTextColor;\n          }\n\n          &.custom-option {\n            cursor: pointer;\n\n            .custom-chevron {\n              margin-left: auto;\n              color: $iconColor;\n              font-size: 2.4rem;\n              margin-bottom: 0.5rem;\n            }\n          }\n        }\n      }\n\n      .alarm-modal__recurring-section {\n        h3 {\n          color: $darkTextColor;\n          font-size: 1.6rem;\n          margin-bottom: 1.6rem;\n          font-weight: 600;\n        }\n\n        .recurring-option {\n          input[type='checkbox'].alarm-checkbox {\n            display: none;\n\n            & + label {\n              position: relative;\n              padding-left: 2.2rem;\n              cursor: pointer;\n              display: flex;\n              align-items: center;\n              margin-bottom: 1.5rem;\n              flex: 1;\n\n              &:before {\n                content: '';\n                position: absolute;\n                left: 0;\n                top: 50%;\n                transform: translateY(-50%);\n                width: 1.2rem;\n                height: 1.2rem;\n                border: 1px solid $darkGray;\n                border-radius: 50%;\n                background: $backgroundColor;\n              }\n\n              &:after {\n                content: '';\n                width: 1.2rem;\n                height: 1.2rem;\n                background: $darkTextColor;\n                position: absolute;\n                top: 50%;\n                left: 0px;\n                border-radius: 50%;\n                opacity: 0;\n                transform: translateY(-50%);\n              }\n            }\n\n            &:checked + label:after {\n              opacity: 1;\n            }\n          }\n\n          .normal {\n            font-weight: 500;\n            color: $darkTextColor;\n          }\n        }\n      }\n    }\n\n    &__footer {\n      padding: 0px 0px 2rem;\n      display: flex;\n      justify-content: center;\n\n      .update-alarm-button {\n        color: $darkTextColor;\n        min-width: 120px;\n        font-size: 1.3rem;\n        border: none;\n      }\n    }\n  }\n}\n","$desktop: 1441px;\n$hdlaptop: 1281px;\n$laptop: 1024px;\n$tablet: 768px;\n$mobile: 600px;\n$smobile: 425px;\n\n// Body\n$body-bg: #f5f8fa;\n\n// Borders\n$laravel-border-color: darken($body-bg, 10%);\n$list-group-border: $laravel-border-color;\n$navbar-default-border: $laravel-border-color;\n$panel-default-border: $laravel-border-color;\n$panel-inner-border: $laravel-border-color;\n\n//background\n$background-color: #fff;\n\n$page-min-height: 56rem;\n\n$eventTextSize: 1.1rem;\n\n$headingFontWeight: 200;\n\n// Z-index layers\n$debugLayer: 10000;\n$eventLayer: 100;\n$colorPickerLayer: 200;\n$navLayer: 4000;\n$overEventLayer: 5000;\n$expandedEventLayer: 3500;\n$stickerLayer: 3000;\n$modalOverlayLayer: 5000;\n$modalBaseLayer: 6000;\n$modalConfirmationLayer: 10000;\n$checklistLayer: 500;\n$taskLayer: 500;\n\n$modalConfirmLayer: 6000;\n$modalContentLayer: 10000;\n\n$baseStickerSize: calc((100vw - 34rem - (50vw - 16rem) * 0.25) * 0.05);\n$tabletStickerSize: calc((100vw - 18rem - (50vw - 7rem) * 0.25) * 0.05);\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
